import { useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { useFormik } from "formik";
import * as Yup from "yup";

const checkEmailExists = async (email) => {
  try {
    const response = await axios.get("http://localhost:8000/api/v1/check_email_exists/", {
      params: { email: email },
    });
    return response.data;
  } catch (error) {
    console.error("Error checking email:", error);
    return null;
  }
};

const Signup1 = ({ handlePage, handleEmailChange }) => {
  const [emailError, setEmailError] = useState('');

  const validationSchema = Yup.object({
    email: Yup.string()
      .email("Invalid email address")
      .required("Email is required"),
  });

  const formik = useFormik({
    initialValues: {
      email: "",
    },
    validationSchema,
    onSubmit: async () => {
      setEmailError('');
      const result = await checkEmailExists(formik.values.email);
      if (result?.email_exists) {
        setEmailError('Email already exists');
      } else {
        handlePage(2);
      }
    },
  });

  return (
    <>
      <div className="font-hk flex flex-col justify-center items-center h-screen bg-black bg-opacity-70 ">
        <div className="relative flex flex-col items-center bg-white p-8 rounded-lg shadow-lg justify-around w-[95vw] md:w-[44vw] md:h-[60vh]">
          <button
            className="absolute z-[110] top-3 right-3 text-[30px]"
            onClick={() => {
              handlePage(-1);
            }}
          >
            <i className="fa-regular fa-circle-xmark"></i>
          </button>
          <h1 className="text-3xl font-bold text-gray-800">Sign up with Email</h1>
          <h2 className="text-lg font-medium mb-2 text-gray-600 text-center">
            Enter Your Email Address to continue.
          </h2>
          <form className="w-full" onSubmit={formik.handleSubmit}>
            <div className="mb-6">
              <input
                type="email"
                name="email"
                placeholder="Email"
                onChange={(e) => {
                  formik.handleChange(e);
                  handleEmailChange(e);
                  setEmailError('')
                }}
                onBlur={formik.handleBlur}
                value={formik.values.email}
                className="border-2 border-gray-300 p-2 rounded-lg w-full focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              />
              {formik.touched.email && formik.errors.email && (
                <p className="text-red-500 text-sm">{formik.errors.email}</p>
              )}
            {emailError && (
                <p className="text-red-500 text-sm">{emailError}</p>
              )}
            </div>

            <button
              type="submit"
              className="bg-black text-white px-4 py-2 rounded-lg hover:bg-gray-800 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-opacity-50 w-full mb-4"
            >
              Next
            </button>

            <button onClick={() => handlePage(0)} className="text-sm text-blue-500 hover:text-blue-700">
              Sign in
            </button>
          </form>
        </div>
      </div>
    </>
  );
};

export default Signup1;

